var v1='<div class="panel panel-default"><div class=panel-heading>{{content.title}}</div><div class=panel-body ng-bind-html=content.body></div></div>';
angular.module('account.templates').run(['$templateCache', function ($templateCache) {$templateCache.put('src/app/cards/cards-default.html', v1);}]);
module.exports=v1